import { action, computed, observable, runInAction } from "mobx";
import { createViewModel } from "mobx-utils";
import { api, api_repre, apiOperacao } from "../../api";
import { IEmpresa, IUsuario, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { isMatriz, nameFile, sortBy, toast_error, validarCNPJ } from "../../utils";
import { AppStore } from "../AppStore";

export class _EmpresaStore {

  obs = observable({
    empresa: newEmpresa() as IEmpresa,
    loaded: false as boolean,
    usuarios: [] as IUsuario[],
    usuarios_emp: [] as IUsuario[],
    working: false as boolean,
    confirmarAlert: false as boolean,
    id_empresa: null as IEmpresa,
    valorPlano: null as number,
    plano: [] as any,
    cnpj: "" as string,
    razao_social: "" as string,
    nome_fantasia: "" as string,
    regime_importacao: "" as string,
    filial: false as boolean,
    estado: "" as string,
    simples_nacional: false as boolean,
    regime_especial_icms_pa: false as boolean,
    convenio_icms_100_97: false as boolean,
    medicamento_uso_veterinario: false as boolean,
    auto_pecas: false as boolean,
    simples_nacional_excesso: false as boolean,
    inscricao_estadual: "" as string,
    valorPlanoBusiness: 0 as number,
    disableRegime: false as boolean,
    receita_bruta_ok: false as boolean,
    waitEmpresas: false as boolean,
    exist_pdf: false as boolean,
    existe_pdf_pgdas: false as boolean,
    title_loading: "" as string,
    loading: false as boolean,
    porta_a_porta: false as boolean,
    open_calculadora: false as boolean,
    rendimento_mensal: 0 as number,
    valor_calculado: 0 as number,
    disable_input_cnpj: false as boolean,
    buscando_cnpj: false as boolean,
    status_personalizado: false as boolean,
    isTourOpen: false as boolean,
    isValid: false as boolean,

    empresas: [] as IEmpresa[],
    empresas_all: [] as IEmpresa[],
    currentPageEmp: 1 as number,
    length_empresas: 0 as number,
    count_empresas: 0 as number,

    empresa_edit: {} as IEmpresa,
    empresa_id: "" as string,
    filter: "" as string,
    loading_export: false as boolean,
    loading_import: false as boolean,
    certificado: "" as string,
    status: "" as string,
    // exist_certificado_socio: false as boolean,
    empresas_permissions: [] as IEmpresa[],
  })

  handleDeleteConfirm(row) {
    this.obs.confirmarAlert = true;
    this.obs.id_empresa = row.cipher_id;
  }

  @action
  refresh() {
    window.location.reload();
  }

  @action
  async handleDeleteEmp() {

    this.obs.title_loading = "Deletando empresa..."
    this.obs.confirmarAlert = false;
    this.obs.loading = true;
    this.setWorking(true);

    let resp = await EmpresaStore.delete(this.obs.id_empresa);

    this.setWorking(false);
    this.obs.loading = false;

    if(resp) {

      await this.load_empresas_filter(this.obs.currentPageEmp, this.obs.filter, this.obs.certificado, this.obs.status);

    }

  }

  @action
  async buscaCNPJ(cnpj: any): Promise<void> {

    if (!cnpj) {
      toast.error('Por favor, preencha o CNPJ.', {});
      return;
    }

    if (!validarCNPJ(cnpj)) {
      toast.error('Por favor, preencha um CNPJ válido.', {});
      return;
    }

    if (this.obs.valorPlano == null) {
      toast.warning('Selecione um plano para continuar!', {});
      return
    }

    this.setWorking(true);
    this.obs.buscando_cnpj = true
    this.obs.disable_input_cnpj = true

    try {
      let resp = await apiOperacao("empresas").get(`/empresas/busca-dados-cnpj/${cnpj}`);

      if (resp.data.ok) {

        runInAction(() => {
          this.obs.empresa.razao_social = resp.data.nome;
          this.obs.empresa.nome_fantasia = resp.data.fantasia;

          this.obs.empresa.municipio = resp.data.municipio;
          this.obs.empresa.uf = resp.data.uf;
          this.obs.empresa.logradouro = resp.data.logradouro;
          this.obs.empresa.cep = resp.data.cep;
          this.obs.empresa.bairro = resp.data.bairro;

          if (isMatriz(cnpj)) {
            this.obs.empresa.filial = false;
            this.obs.filial = false;
          } else {
            this.obs.empresa.filial = true;
            this.obs.filial = true;
          }

          this.obs.inscricao_estadual = resp.data.inscricao_estadual
          this.obs.razao_social = resp.data.nome;
          this.obs.nome_fantasia = resp.data.fantasia;
          this.obs.estado = resp.data.uf;
          this.obs.empresa.abertura = resp.data.abertura;

          AppStore.setLocation("/empresa/create");

        })

      } else {

        toast.error(resp.data.message, {});

      }

    } catch (ex) {
      toast_error(ex, `Erro ao Buscar Dados CNPJ, tente novamente mais tarde.`);
    }

    this.setWorking(false);
    this.obs.buscando_cnpj = false
    this.obs.disable_input_cnpj = false
  }

  @action
  async confirmRegimeLog(regime: any, empresa: any): Promise<any> {
    try {
      let params = {
        regime: regime,
        empresa: empresa,
      };

      let resp = await apiOperacao("empresas").post("/empresas/confirmar-alteracao-regime-empresa", params);
      runInAction(() => {
        if (resp.data != "erro") {
          toast.success('Termo aceitado.', {});
          this.obs.disableRegime = true;
        } else {
          toast.error('Não foi possível trocar o Regime.', {});
        }
      });
    } catch (ex) {
      toast.error("Erro ao trocar Regime, tente novamente mais tarde", {});
    }
  }

  @action
  async handleDadosEmpresa(empresa: any): Promise<any> {
    try {

      let resp_usu = await apiOperacao("empresas").get(`/empresas/busca-dados/${empresa}`);

      return resp_usu.data

    } catch (ex) {
      toast_error(ex, `Erro ao buscar dados da empresa, tente novamente mais tarde.`);
    }
  }

  @action
  async usuariosEmpresas(): Promise<any> {

    try {

      let resp = await apiOperacao("user_permissions").get(`/user_permissions/usuarios-empresas`);

      this.obs.usuarios_emp = [];

      if (resp.status == 200) this.obs.usuarios_emp = resp.data

    } catch (ex) {

      toast_error(ex, `Erro ao buscar Usuários Empresas, tente novamente mais tarde.`);

    }

    this.obs.loaded = true;

  }

  @action
  async load(): Promise<void> {
    try {
      let resp = await api.get("/api/empresas-usuario");

      this.obs.empresas_all = [];
      if (resp.status == 200) this.obs.empresas_all = resp.data

    } catch (ex) {
      toast.error("Erro ao consultar total Empresas Plano, tente novamente mais tarde.", {});
    }
  }

  async count_empresas() {

    try {

      let resp = await apiOperacao("empresas").post("/empresas/lista-empresas-paged", {});

      this.obs.count_empresas = resp.data

    } catch (ex) {
      toast_error(ex, `Erro ao carregar Empresas, tente novamente mais tarde.`);
    }

  }

  async load_empresas_filter(page: number, filter: string, certificado: string, status: string) {

    try {

      let texto = filter

      var re = new RegExp(/[0-9]/g)

      if (re.test(texto)) {
        texto = texto.replace(/\./g, "").replace(/\//g, "").replace(/\-/g, "")
      }

      let params = {
        page: page,
        page_size: 10,
        filter: texto,
        certificado: certificado,
        status: status
      }

      let resp = await apiOperacao("empresas").post("/empresas/lista-empresas-paged", params);

      this.obs.empresas = [];
      this.obs.length_empresas = 0

      if (resp.data.itens.length) {

        this.obs.empresas = resp.data.itens
        this.obs.length_empresas = resp.data.count

      }

    } catch (ex) {
      toast_error(ex, `Erro ao filtar Empresas, tente novamente mais tarde.`);
    }
  }

  // @action
  // async doSavePgdasManual(receita_bruta: number, cnpj: string): Promise<void> {
  //   try {
  //     let params = {
  //       receita_bruta,
  //     };

  //     let resp = await api.post(`/api/receita-bruta-manual/${cnpj}`, params);

  //     runInAction(() => {
  //       if (resp.data === "ok") {
  //         this.obs.receita_bruta_ok = true;
  //       }
  //     });
  //   } catch (ex) {
  //     toast.error("Erro ao carregar Receita bruta manual, tente novamente mais tarde.", {});
  //   }
  // }

  @action
  setWorking(working: boolean) {
    this.obs.working = working;
  }

  get(id: any): IEmpresa {
    return this.obs.empresas_all.find(x => x.cipher_id == id);
  }

  getByCnpj(cnpj: string): IEmpresa {
    return this.obs.empresas_all.find(x => x.cnpj == cnpj);
  }

  @computed
  get sortedEmpresas(): IEmpresa[] {
    return sortBy(this.obs.empresas_all, "razao_social");
  }

  @action
  async updateEmpresa(empresa: IEmpresa) {

    this.setWorking(true);

    try {
      let resp = await apiOperacao("empresas").put(`/empresas/update/${empresa.cipher_id}`, empresa);

      if (resp.data.ok) {

        toast.success("Empresa atualizada com sucesso!", {});

        setTimeout(() => { this.refresh(); }, 1000);
      }

    } catch (ex) {

      toast_error(ex, `Erro ao atualizar Empresa, tente novamente mais tarde.`);

    }

    this.setWorking(false);

  }

  async createEmpresa(empresa: IEmpresa) {

    this.setWorking(true);

    try {

      let params = {
        cnpj: this.obs.cnpj,
        razao_social: this.obs.razao_social,
        nome_fantasia: this.obs.nome_fantasia,
        regime_importacao: this.obs.regime_importacao,
        filial: this.obs.filial,
        simples_nacional: this.obs.simples_nacional,
        regime_especial_icms_pa: this.obs.regime_especial_icms_pa,
        convenio_icms_100_97: this.obs.convenio_icms_100_97,
        medicamento_uso_veterinario: this.obs.medicamento_uso_veterinario,
        auto_pecas: this.obs.auto_pecas,
        porta_a_porta: this.obs.porta_a_porta,
        simples_nacional_excesso: this.obs.simples_nacional_excesso,
        inscricao_estadual: this.obs.inscricao_estadual,
        plano: this.obs.plano,
        contador_responsavel: empresa.contador_responsavel,
        perfil_fiscal: empresa.perfil_fiscal,
        uf: this.obs.empresa.uf,
        municipio: this.obs.empresa.municipio,
        logradouro: this.obs.empresa.logradouro,
        cep: this.obs.empresa.cep,
        bairro: this.obs.empresa.bairro,
        sitfis_automatico: this.obs.empresa.sitfis_automatico,
        manifestacao_automatica: this.obs.empresa.manifestacao_automatica,
        manifestacao_automatica_nfse: this.obs.empresa.manifestacao_automatica_nfse,
        calculo_automatico_nivy: this.obs.empresa.calculo_automatico_nivy,
        caixapostal_automatica: this.obs.empresa.caixapostal_automatica,
        rewritexml: this.obs.empresa.rewritexml,
        abertura: this.obs.empresa.abertura
      };

      let resp = await apiOperacao("empresas").post("/empresas/create", params);

      if (resp.data.ok) {

        toast.success("Empresa criada com sucesso!", {});

        this.setWorking(false);

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao criar Empresa, tente novamente mais tarde.`);

    }

    this.setWorking(false);

    return false

  }

  async putPlano(data: any) {
    try {
      let resp = await apiOperacao("empresas").post(`/empresas/put-plano`, data);

      if (resp.data.ok) {
        toast.success("Plano vinculado com sucesso!", {});
        await EmpresaStore.load();

      } else {
        toast.error(resp.data.msg, {});
      }

    } catch (ex) {

      toast_error(ex, `Erro ao vincular Plano na Empresa, tente novamente mais tarde.`);

    }
  }

  @action
  async visualiza_pgdas(empresa: IEmpresa) {

    try {

      let res = await apiOperacao("pgdas").get(`/pgdas/empresa/download/${empresa._id}`);

      if (res.data === "error") {

        toast.error('Não foi possível carregar pgdas, tente novamente mais tarde', {});

      } else {
        const linkSource = `data:application/pdf;base64,${res.data.path}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = nameFile(empresa, "PGDASD-DECLARAÇÃO");
        downloadLink.click();

      }

    } catch (ex) {

      toast_error(ex, `Erro ao baixar PGDAS, tente novamente mais tarde.`);

    }

  }

  // @action
  // async exist_pdf_pref(): Promise<boolean> {
  //   try {
  //     let resp = await api.get(
  //       `/api/existpdfprefeitura/${this.obs.empresa_edit._id}`,
  //     );

  //     return resp.data.status;
  //   } catch (ex) {
  //     toast.error("Erro ao carregar Pdf Prefeitura, tente novamente mais tarde.", {});
  //   }
  // }

  async delete(empresaId: any) {

    try {

      let resp = await apiOperacao("empresas").delete(`/empresas/delete/${empresaId}`);

      if (resp.data.ok) {

        toast.success(`Empresa desativada com sucesso!`, {});

        return true

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao desativar empresa, tente novamente mais tarde.`);

    }

    return false

  }

  @action
  async exist_pdf_pgdas(): Promise<boolean> {
    try {
      let resp = await apiOperacao("pgdas").get(`/pgdas/empresa/exist/${this.obs.empresa_edit._id}`);

      return resp.data.exist;
    } catch (ex) {
      toast_error(ex, `Erro ao carregar arquivo do PGDAS, tente novamente mais tarde.`);
    }
  }

  // async handlePlanoPersonalizado(params) {

  //   try {
  //     let resp = await api.post('/api/add-plano-personalizado', params)

  //     this.obs.status_personalizado = resp.data.ok

  //     if (resp.data.ok) {
  //       toast.success('Valor Atualizado com sucesso!', {});
  //     } else {
  //       toast.error('Não foi possível atualizar.', {});
  //     }
  //   } catch (ex) {
  //     toast.error("Erro ao atualizar Plano Personalizado, tente novamente mais tarde.", {});
  //   }
  // }


  async handleDeleteEmpresa(empresa: any) {
    this.obs.loading = true

    try {

      let params = {
        cipher_id: empresa.cipher_id
      }

      let resp = await api_repre.post("/representante/empresa/delete", params)

      if (resp.data.ok) {

        toast.success('Empresa excluida com sucesso.', {});

        this.obs.loading = false

        setInterval(() => { window.location.reload() }, 2000)

      } else {
        toast.error(resp.data.erro, {});
      }

    } catch (ex) {

      toast_error(ex, `Não foi possível excluir empresa, tente novamente mais tarde.`);

    }

    this.obs.loading = false
  }

  async handleValidaNfse(cnpj: string) {

    try {

      let data = { cnpj: cnpj }

      let resp = await apiOperacao("empresas").post("/empresas/valida/manifestacao/nfse", data)

      return resp.data.ok

    } catch (ex) {

      toast_error(ex, `Não foi possível ativar, tente novamente mais tarde.`);

    }

    return false

  }

  async downloadEmpresaPfx(cnpj: string) {

    try {

      let data = { cnpj: cnpj }

      let resp = await apiOperacao("empresas").post("/empresas/download/pfx", data)

      if (resp.data.ok) {
        const linkSource = `data:application/pfx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        let fileName = `${cnpj}.pfx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao realizar o download, tente novamente mais tarde.`);

    }

  }

  async handleExport() {

    this.obs.loading_export = true

    try {

      let resp = await apiOperacao("empresas").get("/empresas/export-empresas")

      if (resp.data.ok) {

        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_empresas.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.warning(resp.data.error, {});
      }

    } catch (ex) {

      toast_error(ex, `Erro ao exportar, tente novamente mais tarde.`);

    }

    this.obs.loading_export = false

  }

  async handleImportCertificado(data) {

    try {

      let resp = await apiOperacao("empresas").post("/empresas/import/pfx/socio", data)

      if (resp.data.ok) {

        return resp.data.validade

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao importar certificado, tente novamente mais tarde.`);

    }

    return ""

  }

  async handleDeletaCertificadoSocio(cnpj: string) {

    try {

      let resp = await apiOperacao("empresas").delete(`/empresas/deleta/pfx/socio/${cnpj}`);

      if (resp.data.ok) {

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao deletar certificado, tente novamente mais tarde.`);

    }

    return false

  }

  async exportPlanilhaModelo(){

    this.obs.loading_export = true

    try {

      let resp = await apiOperacao("empresas").get("/empresas/export-modelo")

      if (resp.data.ok) {

        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "planilha_modelo_empresas.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.warning(resp.data.error, {});
      }

    } catch (ex) {

      toast_error(ex, `Erro ao exportar, tente novamente mais tarde.`);

    }

    this.obs.loading_export = false
  }

  async importPlanilhaEmpresa(file) {
    this.obs.loading_import = true;
  
    if (!file) {
      toast.warning("Nenhum arquivo selecionado.");
      this.obs.loading_import = false;
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const resp = await apiOperacao("empresas").post("/empresas/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
  
      if (resp.data.ok) {

        this.obs.loading_import = false;

        return resp.data

      } else {
        toast.error(resp.data.error || "Erro na importação.");
      }
  
    } catch (ex) {

      toast_error(ex, `Erro ao importar, tente novamente mais tarde.`);

    }

    this.obs.loading_import = false;

    return []
  
  }

  async handleUpdateUser(params) {

    try {

      let resp = await apiOperacao("user_permissions").post('/user_permissions/update-usuario-empresa', params)

      if (resp.data.ok) {

        toast.success('Usuário atualizado com sucesso!', {});

        await EmpresaStore.usuariosEmpresas();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Não foi possível atualizar o usuário para essa empresa, contate o suporte para mais detalhes.`);

    }

  }

  async handleCreateUser(params) {

    try {

      let resp = await apiOperacao("user_permissions").post('/user_permissions/add-usuario-empresa', params)

      if (resp.data.ok) {

        toast.success('Usuário criado com sucesso!', {});

        await EmpresaStore.usuariosEmpresas();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Não foi possível criar um usuário para essa empresa, contate o suporte para mais detalhes.`);

    }

  }

  handleDeletaUsuario = async (usuario: any) => {

    try {

      var id = (usuario._id || usuario.id);

      let resp = await apiOperacao("user_permissions").get(`/user_permissions/usuario-empresa/delete?id=${id}`);

      if (resp.data.ok) {

        toast.success('Usuário deletado com sucesso', {});

        await EmpresaStore.usuariosEmpresas();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Não foi possível criar um usuário para essa empresa, contate o suporte para mais detalhes.`);

    }

  };

  /**
   * Altera o modo de execução.
   * 
   * @param mode browser | api
   * @returns true se sucesso, false caso contrário
   */
  handleChangeDecType = async (mode: string) => {

    try {

      let resp = await apiOperacao("dec_sefa").put(`/dec_sefa/mode/enable/empresa/${this.obs.empresa_edit._id}/${mode}`);

      if (resp.data.ok) {

        toast.success("Modelo de consulta atualizado com sucesso!", {});
        return true

      } else {

        toast.error(resp.data.msg, {});
        return false

      }

    } catch (ex) {

      toast_error(ex, (ex?.response?.data?.msg || "Ocorreu um erro, tente novamente mais tarde!"));
      return false

    }

  };

  async empresas_all(): Promise<void> {

    try {

      let resp = await apiOperacao("user_permissions").get("/user_permissions/empresas");

      this.obs.empresas_permissions = [];
      this.obs.empresas_permissions = resp.data

    } catch (ex) {

      toast_error(ex, `Erro ao consultar total Empresas Plano, tente novamente mais tarde.`);

    }

  }

  get sortedEmpresasPermissions(): IEmpresa[] {

    return sortBy(this.obs.empresas_permissions, "razao_social");

  }

}

export const EmpresaStore = new _EmpresaStore();
